import { useState } from "react";
import OldBalanceSheet from "./components/BalanceSheet/OldBalanceSheet";
import NewBalanceSheet from "./components/BalanceSheet/NewBalanceSheet";

const BalanceSheet1 = ({ authrztn }) => {
  const [selectedValue, setSelectedValue] = useState("NEW");

  return (
    <div className="h-100 w-100 bg-white rounded">
      {selectedValue === "OLD" ? (
        <OldBalanceSheet authrztn={authrztn} />
      ) : selectedValue === "NEW" ? (
        <NewBalanceSheet authrztn={authrztn} />
      ) : null}
    </div>
  );
};

export default BalanceSheet1;
